import React, { Fragment } from "react";

export default props =>
    <Fragment>
        <p style={{fontWeight: 'bold'}}>{props.title}</p>
        {props.children}
    </Fragment>